import React from 'react';
import { Table, Card } from 'antd';
import dayjs from 'dayjs';

/**
 * Component for displaying cost history in a table
 * @param {Object} props - Component props
 * @param {Array} props.costs - Array of cost objects to display
 * @param {boolean} props.loading - Loading state for the table
 */
const CostsTable = ({ costs, loading }) => {
  const columns = [
    {
      title: 'Brand',
      dataIndex: 'brand_name',
      key: 'brand_name',
    },
    {
      title: 'Cost Type',
      dataIndex: 'cost_type_display',
      key: 'cost_type_display',
    },
    {
      title: 'Supplier',
      dataIndex: 'supplier_name',
      key: 'supplier_name',
    },
    {
      title: 'Cost Per Mailing',
      dataIndex: 'cost_per_mailing',
      key: 'cost_per_mailing',
      render: (value) => `$${parseFloat(value).toFixed(4)}`,
    },
    {
      title: 'Date Added',
      dataIndex: 'date_added',
      key: 'date_added',
      render: (date) => dayjs(date).format('YYYY-MM-DD HH:mm'),
    },
  ];

  return (
    <Card title="Cost History" size="small" className="mb-4" style={{ height: 'calc(100vh - 200px)', overflowY: 'auto' }}>
      <Table
        columns={columns}
        dataSource={costs}
        rowKey="id"
        loading={loading}
        pagination={false}
        size="small"
        scroll={{ y: 'calc(100vh - 300px)' }}
      />
    </Card>
  );
};

export default CostsTable;
